import {useLanguage} from './LanguageContext';

export const useLocalization = () => {
  const {getString, getStrings, currentLanguage, changeLanguage} =
    useLanguage();

  // Check if translation key exists
  const hasKey = (key) => {
    const strings = getStrings();
    return key in strings;
  };

  // Function-based ApplicationString for backward compatibility
  const ApplicationString = (key) => getString(key, key);

  // Add common translation keys as properties if needed
  const strings = getStrings();
  Object.keys(strings).forEach((key) => {
    if (key) {
      ApplicationString[key] = getString(key, key);
    }
  });

  return {
    hasKey,
    currentLanguage,
    changeLanguage,
    getString,
    getStrings,
    ApplicationString,
  };
};

export default useLocalization;
